import compareReducer from "./compareReducer";
import productDetailsReducer from "./productDetailsReducer";

import { combineReducers } from "redux";

const allReducers = combineReducers({
    compare: compareReducer,
    productDetails: productDetailsReducer
});

export default allReducers;